var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"certificate"},[_c('div',{staticClass:"examine"},[_c('p',[_vm._v("待我操作")]),_c('span',{on:{"click":_vm.viewAll}},[_vm._v("查看全部")])]),_c('avue-crud',{attrs:{"data":_vm.data,"option":_vm.option}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }